import { Navigate, NavLink, Routes, useLocation } from 'react-router-dom';

import { PointChangeFragment } from '@occc/graphql';
import { Tab, Tabs } from '@occc/ui-design-system';

import { Page, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { SentryRoute as Route } from '@occc-app/App/sentry';
import { PointChangeView } from '@occc-app/routes/Transactions/PointChangeView/PointChangeView';
import { PointChangeViewEventData } from '@occc-app/routes/Transactions/PointChangeView/PointChangeViewEventData';
import {
  hasEventData,
  isLoyaltyEventPointChange,
} from '@occc-app/routes/Transactions/PointChangeView/utils';

import { detailsTabLabel, eventDataTabLabel, pageTitle } from './copies';
import { useLinks } from './hooks';

type TabValue = 'details' | 'event-data';

type Props = {
  pointChange: PointChangeFragment;
};

export const MemberPointChangeDetailsPage = (props: Props) => {
  const { pointChange } = props;
  const { id, membership } = pointChange;

  useAppLayoutContextConsumer(useLinks(membership, id));

  const location = useLocation();

  const loyaltyEventPointChange = isLoyaltyEventPointChange(pointChange) ? pointChange : undefined;

  const shouldShowEventDataTab =
    !!loyaltyEventPointChange && hasEventData(loyaltyEventPointChange.source.eventData);

  const currentTab: TabValue =
    shouldShowEventDataTab && location.pathname.includes('/event-data') ? 'event-data' : 'details';

  return (
    <Page browserTabTitle={pageTitle} pageHeaderProps={{ title: pageTitle }}>
      <Tabs value={currentTab} color='secondary'>
        <Tab value='details' label={detailsTabLabel} component={NavLink} to='details' />
        {shouldShowEventDataTab && (
          <Tab value='event-data' label={eventDataTabLabel} component={NavLink} to='event-data' />
        )}
      </Tabs>

      <Routes>
        <Route path='/details' element={<PointChangeView pointChange={pointChange} />} />
        {shouldShowEventDataTab && (
          <Route
            path='/event-data'
            element={<PointChangeViewEventData pointChange={loyaltyEventPointChange} />}
          />
        )}
        <Route path='*' element={<Navigate to='details' replace />} />
      </Routes>
    </Page>
  );
};
